module.exports = __webpack_public_path__ + "static/home-ftp-f934382ebea04e0c1b9ecdb437d6a145.png";